import Constants from "./Constants";

const checkIcon = Constants.ICON_CHECK;
const errorIcon = Constants.ICON_ERROR;

export function showErrorToast(ref, message){
    let toastMessages = [...ref.state.toastMessages];
    toastMessages.push({
        id: Math.floor((Math.random() * 101) + 1),
        title: 'Error',
        description: message,
        backgroundColor: '#d9534f',
        icon: errorIcon
    });
    ref.setState({toastMessages: toastMessages});
}

export function showSuccessToast(ref){
    let toastMessages = [...ref.state.toastMessages];
    toastMessages.push({
        id: Math.floor((Math.random() * 101) + 1),
        title: 'Success',
        description: 'The bracket was published successfully',
        backgroundColor: '#5cb85c',
        icon: checkIcon
    });
    ref.setState({toastMessages: toastMessages});
}

export function showInfoToast(ref, message){
    let toastMessages = [...ref.state.toastMessages];
    toastMessages.push({
        id: Math.floor((Math.random() * 101) + 1),
        title: 'Success',
        description: message,
        backgroundColor: '#4a4d4e',
        icon: checkIcon
    });
    ref.setState({toastMessages: toastMessages});
}


export function getPublishSuccessToast(){
    return {
        id: Math.floor((Math.random() * 101) + 1),
        title: 'Success',
        description: 'The bracket was published successfully',
        backgroundColor: '#5cb85c',
        icon: checkIcon
    };
}
export function getErrorToast(message){
    return {
        id: Math.floor((Math.random() * 101) + 1),
        title: 'Error',
        description: message,
        backgroundColor: '#d9534f',
        icon: errorIcon
    };
}

export function getInfoToast(message){
    return {
        id: Math.floor((Math.random() * 101) + 1),
        title: 'Success',
        description: message,
        backgroundColor: '#4a4d4e',
        icon: checkIcon
    };
}
